import Utils from "platform/util/Utils";
import {Logger} from "platform/logger/Logger";

export class Clarity {

    private static _logger: Logger = Logger.Of("Clarity");
    private static _detectTimeoutHandler: any;
    private static _detectIntervalHandler: any;

    private constructor() {
    }

    public static Identify = (userId: number): void => {
        if (Utils.isNull(this._detectTimeoutHandler)) {
            this._detectTimeoutHandler = setTimeout(() => {
                clearInterval(this._detectIntervalHandler);
            }, 10000);
            this._detectIntervalHandler = setInterval(() => {
                const clarity = (window as any).clarity;
                if (Utils.isNotNull(clarity)) {
                    clearInterval(this._detectIntervalHandler);
                    clearTimeout(this._detectTimeoutHandler);
                    clarity("set", "customerId", userId?.toString(10));
                    clarity("identify", userId?.toString(10)).then((res: {
                        userHint: string; // DD*****
                        userId: string; // hash(userId)
                    }) => {
                        Clarity._logger.debug(`User ID: ${res.userId}`);
                    }).catch((e) => {
                        Clarity._logger.debug("Failed to identify", e);
                    });
                }
            }, 500);
        }
    }
}
